import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues } from "@/utils/formHelper";
import { omittedValues } from "@/utils/qrEditorHelper";
import { qrTextValidation } from "@/utils/validators/qr-text";

import { QRTextProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export const QRText = ({ data }: QRTextProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"text">>(QREditorContext);

  const [qrTextData, setQrTextData] = React.useState<QRProps<"text">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataTextWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    setQrData({ ...qrData, data: { ...qrData.data, [field]: value } }, omittedValues(qrData.data));
  };

  React.useEffect(() => {
    setQrTextData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrTextData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-text">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataTextWithDefaultValues}
        schema={qrTextValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
